<template>
  <div class="h-100">
    <div class="auth h-100">
      <div class="auth--header">
        <img
          src="/img/logo-light.png"
          style="max-width: 95%;"
          alt="">
      </div>

      <div class="auth--content">
        <transition name="fade">
          <router-view/>
        </transition>
      </div>

      <div class="auth--footer">
        <Version />
      </div>
    </div>
  </div>
</template>

<script>
  import Version from '@/shared/components/Version'

  export default {
    name: 'Auth',

    components: {
      Version
    }
  }
</script>



// WEBPACK FOOTER //
// resources/js/auth/Auth.vue